var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "fieldset",
      { staticClass: "filter-fieldset", class: _vm.value ? "open" : null },
      [
        _c(
          "legend",
          {
            on: {
              click: function ($event) {
                _vm.value = !_vm.value
                _vm.$emit("input", _vm.value)
              },
            },
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.t(_vm.$props.title)))]),
            _vm._v(" "),
            _c("span", { staticClass: "fieldset-toggle" }),
          ]
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }